/* eslint-disable react/no-children-prop */
import React from 'react';
import { Button, ButtonProps } from '@chakra-ui/react';
// import { AddIcon } from '@chakra-ui/icons';
import { Plus } from 'phosphor-react';

interface CreateButtonProps extends ButtonProps {
  onClick?: () => void;
}

export const CreateButton = ({ onClick, children, ...rest }: CreateButtonProps) => {
  return (
    <Button
      onClick={onClick}
      variant="solid"
      colorScheme="button.primary"
      leftIcon={<Plus size={14} />}
      {...rest}
    >
      {children}
    </Button>
  );
};
